import { render, staticRenderFns } from "./EditMembership.vue?vue&type=template&id=86215e66&scoped=true"
import script from "./EditMembership.vue?vue&type=script&lang=js"
export * from "./EditMembership.vue?vue&type=script&lang=js"
import style0 from "./EditMembership.vue?vue&type=style&index=0&id=86215e66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86215e66",
  null
  
)

export default component.exports